import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {FolderModel} from "../../models/folder.model";
import {AddTagModel} from "../../models/add-tag.model";

@Component({
  selector: 'add-tag-modal',
  templateUrl: './add-tag-modal.component.html',
  styleUrls: ['./add-tag-modal.component.css']
})
export class AddTagModalComponent implements OnInit {

  @Output() addTagEvent = new EventEmitter<AddTagModel>();
  @Output() closeEvent = new EventEmitter();
  @Output() tagChangedEvent = new EventEmitter();
  @Input() addTagErrorMessage: string;
  @Input() artistFolders: FolderModel[];
  @Input() albumFolders: FolderModel[];
  addTagForm: FormGroup;

  constructor() { }

  ngOnInit() {
    this.addTagForm = new FormGroup({
      tag: new FormControl(''),
      // TODO remove these 'magic numbers' -1 and -2 for all artists and all albums
      folderId: new FormControl(-1)   // -1 as ID is All artists, -2 is All albums
    });
    this.addTagForm.valueChanges.subscribe(value => {
      this.tagChangedEvent.emit();
    });
  }

  addTag() {
    this.addTagEvent.emit(this.addTagForm.value);
  }

  cancel($event) {
    if ($event.currentTarget === $event.target) {
      this.closeEvent.emit();
    }
  }

  getTag(): FormControl {
    return this.addTagForm.get('tag') as FormControl;
  }
}
